import dynamic from 'next/dynamic'

const DynamicLightbox = dynamic(
    () => import('@components/display/photos/Lightbox'),
    { ssr: false }
)

const Lightbox = (props) => <DynamicLightbox {...props} />

export default Lightbox